import { forwardRef } from "react"
import type {
  ComponentPropsWithoutRef,
  Ref,
} from "react"

import { useDataAttributionInGraph } from "../hooks/"

type Props = ComponentPropsWithoutRef<"div">

export const DataAttribution = forwardRef<HTMLDivElement, Props>(
  function DataAttribution(props: Props, propsRef: Ref<HTMLDivElement>) {
    const dataAttribution = useDataAttributionInGraph()
    if (!dataAttribution) {
      return null
    }

    return (
      <div
        {...props}
        ref={propsRef}
        id="dexcom-branding"
      >
        {dataAttribution}
      </div>
    )
  },
)
